import { NgForm } from '@angular/forms';
import { FnInputValueAccessor } from '../../core';
import {
	ElementRef,
	Input,
	Output,
	EventEmitter,
	OnInit,
	HostListener,
	OnChanges,
    Component,
} from '@angular/core';

@Component({
    template: ''
 })
export class FnSelectModel
	extends FnInputValueAccessor<string>
	implements OnInit, OnChanges
{
	/**
	 * Creates an instance of fn select component.
	 */
	constructor(private elementRef: ElementRef) {
		super();
	}
	/**
	 * Determines whether drop down open is
	 */
	isDropDownOpen = false;
	/**
	 * Input member variable
	 * name of field used to set control and  Placeholder if not placeholder is undefined.
	 */
	@Input() name = '';
	/**
	 * Input member variable
	 * used to set id of single select element
	 */
	@Input() id = '';
	/**
	 * Input  member variable
	 * if true then show error if single select control is invalid.
	 */
	@Input() isErrorBox = true;
	/**
	 * Input member variable
	 * used to show drop-down data list.
	 */
	@Input() optionList: Array<any> = [];
	/**
	 * Input member variable
	 * custom property for display
	 */
	@Input() labelKey = '';
	/**
	 * Input member variable
	 * used to show placeholder in single select
	 */
	@Input() placeholder = '';
	/**
	 * Input member variable
	 * used to validate Single Select if true then Select value Cannot be null or empty;
	 */
	@Input() isRequired = false;
	/**
	 * Input member variable
	 * used to pass the form object to show error message
	 */
	@Input() parentForm: NgForm;
	/**
	 * Input member variable
	 * default value = 0
	 * used to set the tabindex of input tag
	 */
	@Input() tabIndex = 0;
	/**
	 * Input member variable
	 * grouping Dropdown Items providing key name as a string
	 */
	@Input() groupBy = '';
	/**
	 * Input  member variable
	 * used to Append DropDown To given Element
	 */
	@Input() appendTo = '';
	/**
	 * Input  member variable
	 * if true then clear select element on backspace
	 */
	@Input() clearOnBackspace = true;
	/**
	 * Input  member variable
	 * if true then clear select element
	 */
	@Input() isReset: boolean = false;
	/**
	 * Output member
	 * Fired on model change. Outputs whole model
	 */
	@Output() changeEvent: EventEmitter<any> = new EventEmitter();
	/**
	 * Output member
	 * Fired on select dropdown close
	 */
	@Output() closeEvent: EventEmitter<any> = new EventEmitter();
	/**
	 * Implements onInit event handler
	 */
	ngOnInit(): void {
		this.setOption();
	}

	ngOnChanges() {
		if (this.isReset) {
			this.value = null;
		}
	}
	/**
	 * Sets PlaceHolder Value.
	 */
	setOption() {
		this.placeholder = this.placeholder || this.name;
	}
	/**
	 * Method to call updateDropDownPostion when append to Value is Given
	 */
	onOpen() {
		this.isDropDownOpen = true;
		if (this.appendTo) {
			this.updateDropDownPostion();
		}
	}

	onClose(event?: Event) {
		this.isDropDownOpen = false;
	}
	/**
	 * method Updates drop down postion when append to Value is Given
	 */
	updateDropDownPostion() {
		const select = this.elementRef.nativeElement as HTMLElement;
		const parentElem = document.querySelector(this.appendTo) as HTMLElement;
		const dropDown = document.querySelector('ng-dropdown-panel') as HTMLElement;
		if (!dropDown) {
			setTimeout(() => {
				this.updateDropDownPostion();
			});
		} else {
			const parentDomRect = parentElem.getBoundingClientRect();
			const selectDomRect = select.getBoundingClientRect();
			const offsetLeft = selectDomRect.left - parentDomRect.left;
			dropDown.style.left = offsetLeft + 'px';
			dropDown.style.width = selectDomRect.width + 'px';
			dropDown.style.minWidth = selectDomRect.width + 'px';
		}
	}

	emitSelectedValue(val: any) {
		this.changeEvent.emit(val);
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?: Event) {
		if (this.isDropDownOpen && this.appendTo) {
			this.updateDropDownPostion();
		}
	}
}
